import { z } from 'zod'

const envSchema = z.object({
  VITE_APP_TITLE: z.string().min(1).default('Convbased Dashboard'),
  VITE_API_BASE_URL: z.string().min(1).default('/api'),
  VITE_API_TIMEOUT: z.coerce.number().int().positive().default(15_000),
  VITE_AUTH_MODE: z.enum(['demo', 'required']).default('demo'),
})

const parsed = envSchema.safeParse(import.meta.env)

if (!parsed.success) {
  console.error('Invalid environment variables', parsed.error.flatten().fieldErrors)
  throw new Error('Invalid application environment')
}

export const env = {
  appTitle: parsed.data.VITE_APP_TITLE,
  apiBaseUrl: parsed.data.VITE_API_BASE_URL,
  apiTimeout: parsed.data.VITE_API_TIMEOUT,
  authMode: parsed.data.VITE_AUTH_MODE,
} as const
